/* ============================================================
   Kaynaturalz — Product Page (PDP) interactions (Shopify build)
   Gallery thumbs, purchase options, accordions, sticky add bar.
   Add-to-bag goes straight to the real Shopify cart via the
   shared window.KNCart API exposed by kn-design-app.js.

   STOCK TRUTH
   Liquid renders the correct stock state on load. This file keeps it
   correct afterwards, in four places:
     1. the page confirms against live product JSON as soon as it loads,
        because the HTML itself may be a cached copy a few minutes old
     2. switching variant repaints the buttons from that variant's
        data-available flag
     3. returning to a tab that has been open a while re-reads the live
        product JSON and repaints, so a page left open overnight cannot
        offer something that sold out in the meantime
     4. the click itself re-checks availability before adding, so the
        last word always belongs to Shopify, not to the rendered page
   ============================================================ */
(function () {
  "use strict";
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var money = function (n) { return "$" + n.toFixed(2); };

  /* ---------- marquee: duplicate for seamless loop ---------- */
  var mq = $("#mq");
  if (mq) mq.innerHTML += mq.innerHTML;

  /* ---------- gallery thumbnails ---------- */
  var thumbs = $("#thumbs"), mainImg = $("#mainImg");

  /* The main image ships a srcset so phones download a phone-sized file.
     A srcset always beats a plain src, so any swap has to drop it first
     or the gallery would appear frozen on the first photo. */
  function setMain(url, contain) {
    if (!mainImg || !url) return;
    mainImg.removeAttribute("srcset");
    mainImg.removeAttribute("sizes");
    mainImg.src = url;
    if (contain) mainImg.classList.add("contain");
    else mainImg.classList.remove("contain");
  }

  /* Small screens get the smaller variant of the full-size url. */
  function pickFull(el, bigAttr, smallAttr) {
    var sm = el.getAttribute(smallAttr);
    if (sm && window.innerWidth <= 860) return sm;
    return el.getAttribute(bigAttr) || "";
  }

  if (thumbs && mainImg) {
    thumbs.addEventListener("click", function (e) {
      var b = e.target.closest(".thumb");
      if (!b) return;
      thumbs.querySelectorAll(".thumb").forEach(function (t) { t.classList.remove("is-on"); });
      b.classList.add("is-on");
      var img = b.querySelector("img");
      if (img) {
        var url = pickFull(img, "data-full", "data-full-sm") || img.src;
        setMain(url, img.getAttribute("data-fit") === "contain");
      }
    });
  }

  /* ---------- purchase options (real Shopify variants) ---------- */
  var opts = $("#opts");
  var addBtn = $("#addBtn");
  var addBtnSticky = $("#addBtnSticky");
  var stickyPrice = $("#stickyPrice");
  var priceNow = $("#priceNow");
  var priceWas = $("#priceWas");
  var state = { variantId: null, price: 0, compare: null, label: "", available: true };

  function readOpt(o) {
    state.variantId = parseInt(o.getAttribute("data-variant"), 10) || null;
    state.price = parseFloat(o.getAttribute("data-price"));
    state.compare = parseFloat(o.getAttribute("data-compare")) || null;
    state.label = o.getAttribute("data-label");
    state.available = o.getAttribute("data-available") !== "false";
  }

  /* Swap the gallery to the selected variant's image (if it has one). */
  function syncVariantImage(o) {
    if (!mainImg) return;
    var big = o.getAttribute("data-img");
    if (!big) return;
    var vimg = pickFull(o, "data-img", "data-img-sm");
    setMain(vimg, false);
    if (thumbs) {
      var match = null;
      thumbs.querySelectorAll(".thumb img").forEach(function (t) {
        if ((t.getAttribute("data-full") || "") === big) match = t;
      });
      if (match) {
        thumbs.querySelectorAll(".thumb").forEach(function (t) { t.classList.remove("is-on"); });
        match.closest(".thumb").classList.add("is-on");
        if (match.getAttribute("data-fit") === "contain") mainImg.classList.add("contain");
      }
    }
  }

  // Preserve any rating suffix (e.g. " · ★ 4.9") baked into the sticky bar by Liquid.
  var stickySuffix = "";
  if (stickyPrice) {
    var _idx = stickyPrice.textContent.indexOf("·");
    if (_idx >= 0) stickySuffix = " " + stickyPrice.textContent.slice(_idx);
  }

  function paintButtons() {
    if (addBtn && !addBtn.classList.contains("added")) {
      if (state.available === false) {
        addBtn.disabled = true;
        addBtn.textContent = "Sold Out";
      } else {
        addBtn.disabled = false;
        addBtn.textContent = "Add to Bag — " + money(state.price);
      }
    }
    if (addBtnSticky && !addBtnSticky.classList.contains("added")) {
      if (state.available === false) {
        addBtnSticky.disabled = true;
        addBtnSticky.textContent = "Sold Out";
      } else {
        addBtnSticky.disabled = false;
        addBtnSticky.textContent = "Add to Bag";
      }
    }
  }

  function syncPrice() {
    if (priceNow && !isNaN(state.price)) priceNow.textContent = money(state.price);
    if (priceWas) {
      if (state.compare && state.compare > state.price) { priceWas.textContent = money(state.compare); priceWas.hidden = false; }
      else { priceWas.hidden = true; }
    }
    if (stickyPrice && !isNaN(state.price)) stickyPrice.textContent = money(state.price) + stickySuffix;
    paintButtons();
  }

  if (opts && opts.querySelector(".opt")) {
    var initial = opts.querySelector(".opt.is-on") || opts.querySelector(".opt");
    if (initial) readOpt(initial);
    opts.addEventListener("click", function (e) {
      var o = e.target.closest(".opt");
      if (!o) return;
      opts.querySelectorAll(".opt").forEach(function (x) { x.classList.remove("is-on"); });
      o.classList.add("is-on");
      readOpt(o);
      syncPrice();
      syncVariantImage(o);
    });
  } else if (addBtn && addBtn.getAttribute("data-sv")) {
    // Single-variant product: read the variant straight off the Add button.
    state.variantId = parseInt(addBtn.getAttribute("data-sv"), 10) || null;
    state.price = parseFloat(addBtn.getAttribute("data-sv-price"));
    state.compare = parseFloat(addBtn.getAttribute("data-sv-compare")) || null;
    state.available = !addBtn.disabled;
  }
  syncPrice();

  /* The first paint came from Liquid, which may be a cached copy of the
     page. Confirm it against live Shopify data straight away. */
  refreshStock();

  /* ---------- live stock, read straight from Shopify ---------- */
  function productUrl() {
    return window.location.pathname.split("?")[0].replace(/\/$/, "") + ".js";
  }

  /* Returns a promise for a map of variantId -> available, or null. */
  function fetchStock() {
    return fetch(productUrl(), { cache: "no-store", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return null;
        var map = {};
        p.variants.forEach(function (v) { map[v.id] = v.available; });
        return map;
      })
      .catch(function () { return null; });
  }

  /* Repaint every option and the buttons from live data. */
  function refreshStock() {
    return fetchStock().then(function (map) {
      if (!map) return;
      if (opts) {
        opts.querySelectorAll(".opt").forEach(function (o) {
          var id = parseInt(o.getAttribute("data-variant"), 10);
          if (!(id in map)) return;
          var ok = !!map[id];
          o.setAttribute("data-available", ok ? "true" : "false");
          o.classList.toggle("is-soldout", !ok);
          var name = o.querySelector(".opt__name");
          if (name) {
            var tag = name.querySelector(".opt__oos");
            if (!ok && !tag) {
              tag = document.createElement("span");
              tag.className = "opt__oos";
              tag.textContent = "Sold out";
              name.appendChild(tag);
            } else if (ok && tag) {
              tag.parentNode.removeChild(tag);
            }
          }
        });
      }
      if (state.variantId && state.variantId in map) {
        state.available = !!map[state.variantId];
        paintButtons();
      }
    });
  }

  /* A tab left open can go stale. Re-read on return. */
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) refreshStock();
  });
  window.addEventListener("pageshow", function (e) { if (e.persisted) refreshStock(); });

  /* ---------- quantity stepper (if present) ---------- */
  var qty = $("#qty");
  function getQty() { return Math.max(1, parseInt(qty && qty.value, 10) || 1); }
  if (qty) {
    $("#qMinus").addEventListener("click", function () { qty.value = Math.max(1, getQty() - 1); });
    $("#qPlus").addEventListener("click", function () { qty.value = getQty() + 1; });
    qty.addEventListener("change", function () { qty.value = getQty(); });
  }

  /* ---------- add to bag (real cart) ---------- */
  function addToBag(btn, restoreLabel) {
    if (!state.variantId || !window.KNCart) return;
    if (state.available === false) { paintButtons(); return; }
    var orig = restoreLabel || (btn && btn.textContent);
    var wanted = state.variantId;

    /* Ask Shopify one more time before we take the money. If it sold out
       while this page was open, say so instead of adding it. */
    fetchStock().then(function (map) {
      if (map && wanted in map && !map[wanted]) {
        state.available = false;
        refreshStock();
        if (btn) {
          btn.textContent = "Just sold out";
          setTimeout(function () { paintButtons(); }, 2200);
        }
        return;
      }
      return window.KNCart.add(wanted, getQty()).then(function () {
        if (btn) {
          btn.classList.add("added");
          btn.textContent = "✓ Added to Bag";
          setTimeout(function () { btn.classList.remove("added"); syncPrice(); }, 1500);
        }
        window.KNCart.open();
      }).catch(function (e) {
        if (btn) {
          btn.textContent = (e && e.description) ? "Sold out — restocking soon" : "Try again";
          setTimeout(function () { syncPrice(); }, 2000);
        }
        refreshStock();
      });
    });
  }
  if (addBtn) addBtn.addEventListener("click", function () { if (!addBtn.disabled) addToBag(addBtn); });
  if (addBtnSticky) addBtnSticky.addEventListener("click", function () { if (!addBtnSticky.disabled) addToBag(addBtnSticky); });

  /* ---------- accordions ---------- */
  var acc = $("#acc");
  if (acc) {
    acc.addEventListener("click", function (e) {
      var h = e.target.closest(".acc__head");
      if (!h) return;
      var item = h.parentElement, panel = h.nextElementSibling;
      if (item.classList.contains("is-open")) {
        item.classList.remove("is-open"); panel.style.maxHeight = null;
      } else {
        item.classList.add("is-open"); panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
    acc.querySelectorAll(".acc__item.is-open .acc__panel").forEach(function (p) {
      p.style.maxHeight = p.scrollHeight + "px";
    });
  }

  /* ---------- reveal safety net ---------- */
  (function () {
    var els = document.querySelectorAll(".reveal");
    if (!els.length) return;
    function settle(el) {
      el.classList.add("in");
      setTimeout(function () {
        el.style.transition = "none";
        el.style.opacity = "1";
        el.style.transform = "none";
      }, 850);
    }
    if ("IntersectionObserver" in window) {
      var ro = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (en.isIntersecting) { settle(en.target); ro.unobserve(en.target); }
        });
      }, { threshold: 0.08 });
      els.forEach(function (e) { ro.observe(e); });
      window.addEventListener("load", function () {
        setTimeout(function () { els.forEach(settle); }, 1500);
      });
    } else {
      els.forEach(settle);
    }
  })();

  /* ---------- sticky add bar ---------- */
  var addBox = $(".buy__actions"), sbar = $("#stickybar");
  if (addBox && sbar && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (en) {
      var e = en[0];
      sbar.classList.toggle("is-on", !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(addBox);
  }
})();
